import { useApi, useToaster } from "@shopexperts/shared";
import { useMutation, useQueryClient } from "@tanstack/vue-query";
import type { UpdateRedirectRequest } from "@shopexperts/shared";

interface UpdateRedirectParams {
  id: number;
  data: UpdateRedirectRequest;
}

export function useUpdateRedirect() {
  const api = useApi();
  const queryClient = useQueryClient();
  const toaster = useToaster();

  return useMutation({
    mutationFn: ({ id, data }: UpdateRedirectParams) => 
      api.admin.redirects.update({ params: { id }, body: data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'redirects'] });
      toaster.create({
        title: "Redirect updated successfully",
        type: "success",
      });
    },
    onError: (error: any) => {
      console.error('[useUpdateRedirect] Error:', error);
      
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.error ||
        error?.message ||
        'An error occurred while updating the redirect.';
      
      toaster.create({
        title: "Failed to update redirect",
        description: errorMessage,
        type: "error",
      });
    },
  });
}

